import {Injectable} from "@angular/core";
import {catchError, map} from "rxjs/operators";

import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {CommonPaginationResponse, CommonResponse, processNormal, processPagination} from "../common/response.model";
import {ErrorHandlingService} from "../common/error-handling.service";
import {AttachedDocument} from "../attachments/attachment.model";
import {Validation} from "./validations.model";

@Injectable()
export class ValidationsService {

  constructor(private http: HttpClient, private errorHandling: ErrorHandlingService) {
  }

  getValidations(page, per_page, filter = '') {

    let params = new HttpParams().append('paginate', '1').append('paginate_per_page', per_page.toString()).append('page', page);
    if (filter != '') params = params.append('filter', filter);

    return this.http.get<CommonPaginationResponse<Validation[]>>(
      environment.apiUrl + "validations",
      {
        params: params
      }
    ).pipe(
      map(resp => processPagination(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }


  show(validation: Validation) {

    return this.http.get<CommonResponse<Validation>>(
      environment.apiUrl + "validations/" + validation.id
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  approve(validation: Validation) {

    return this.http.post<CommonResponse<Validation>>(
      environment.apiUrl + "validations/" + validation.id + '/approve',
      {}
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  reject(validation: Validation) {

    return this.http.post<CommonResponse<Validation>>(
      environment.apiUrl + "validations/" + validation.id + '/reject',
      {
        reason: validation.reason
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }
}
